import { createContext, ReactElement, useContext } from 'react';

import { RecordSummaryProps } from '@app/components';

export interface RecordSummaryContextProps extends RecordSummaryProps {
  isInstanceDetails: boolean;
  isMobileInstanceDetails: boolean;
  isHoldsAndCheckouts: boolean;
  isMobileHoldsAndCheckouts: boolean;
  isAvailabilityLoadingForTheFirstTime: boolean;
  getItemStatusPanel: () => ReactElement;
  toggleIsPlaceHoldModalOpen: () => void;
}

export const RecordSummaryContext = createContext<RecordSummaryContextProps>(
  null!
);

export const useRecordSummaryContext = (): RecordSummaryContextProps =>
  useContext(RecordSummaryContext);
